import { selectAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = 
  createMultiStyleConfigHelpers(selectAnatomy.keys);

const baseStyle = definePartsStyle({
  field: {
    bg: 'gray.700',
    color: 'white',
    borderColor: 'gray.600',
    // Target option elements
    '> option': {
      bg: 'gray.700',
      color: 'white',
    },
  },
  icon: {
    color: 'white',
  },
});

export const selectTheme = defineMultiStyleConfig({ baseStyle });
